var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6275 24 12C24 5.37254 18.6274 0 12 0C5.37259 0 0 5.37254 0 12C0 18.6275 5.37259 24 12 24ZM12 21.5172C17.2562 21.5172 21.5172 17.2563 21.5172 12C21.5172 6.74374 17.2562 2.48276 12 2.48276C6.74376 2.48276 2.48276 6.74374 2.48276 12C2.48276 17.2563 6.74376 21.5172 12 21.5172Z",
    fill: "#00a000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41753 10.0943C7.95449 9.63128 7.95448 8.88054 8.41753 8.41749C8.88057 7.95443 9.63133 7.95442 10.0944 8.41748L11.5151 9.83817C11.7829 10.106 12.217 10.106 12.4848 9.83817L13.9056 8.41738C14.3687 7.95433 15.1194 7.95433 15.5825 8.41739C16.0455 8.88044 16.0455 9.63119 15.5825 10.0942L14.1617 11.515C13.8939 11.7828 13.8939 12.217 14.1617 12.4848L15.5826 13.9058C16.0457 14.3688 16.0457 15.1196 15.5826 15.5826C15.1196 16.0457 14.3688 16.0457 13.9058 15.5826L12.4848 14.1616C12.217 13.8939 11.7829 13.8939 11.5151 14.1616L10.0942 15.5825C9.63116 16.0456 8.8804 16.0456 8.41735 15.5825C7.95431 15.1195 7.95431 14.3687 8.41735 13.9057L9.83823 12.4848C10.106 12.217 10.106 11.7828 9.83823 11.515L8.41753 10.0943Z",
    fill: "#00a000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.a29526872915c3e1f4732f1992056526.svg";
export { ForwardRef as ReactComponent };